<template>
  <header>
    <img alt="sanitas-logo" src="../../assets/sanitasLogo.svg" />
    <p>
      <small>{{ texts.header_label }}</small>
    </p>
  </header>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'Header',
  computed: {
    ...mapGetters(['texts']),
  },
  methods: {
    ...mapActions(['closeSurvey']),
  },
}
</script>

<style lang="postcss" scoped>
header {
  margin-right: 40px;
}

img {
  height: 30px;
}

p {
  margin: 0;
}
</style>
